import { Page } from '@/core/architecture'

import { ResaleRaffleRepaymentConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleRaffleRepaymentConfirmation Page
 * Implemented as a practical sample.
 */
export const ResaleRaffleRepaymentConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ResaleRaffleRepaymentConfirmationTemplate state={state} {...actions} />
  )
}
